module.exports = __webpack_public_path__ + "img/wangjimima1.6a70a818.png";